import React from 'react';
import { cn } from '@/lib/utils';

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        `flex min-h-[96px] w-full rounded-xl border border-input bg-background
         px-4 py-3 text-sm font-medium ring-offset-background
         placeholder:text-muted-foreground/70 leading-relaxed
         transition-all duration-200 resize-none
         focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50
         focus-visible:ring-offset-1 focus-visible:border-primary/60
         hover:border-border/80
         disabled:cursor-not-allowed disabled:opacity-50`,
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
